import { authAtom } from "@src/atoms";
import LoadingSpinner from "@src/components/loading-spinner";
import { checkAuth } from "@src/utils/helpers/check-auth";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

// Public pages are reachable logged in or out. On a fresh load (new tab, shared link,
// refresh) nothing else resolves authAtom, so do it here — without redirecting guests.
function PublicRoute() {
  const [auth, setAuth] = useAtom(authAtom);
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    const validateAuth = async () => {
      if (auth.isAuthenticated === null && !isChecking) {
        setIsChecking(true);
        try {
          const result = await checkAuth();
          setAuth({
            isAuthenticated: result.isAuthenticated,
            user: result.user,
          });
        } catch {
          setAuth({ isAuthenticated: false, user: null });
        } finally {
          setIsChecking(false);
        }
      }
    };
    validateAuth();
  }, [auth.isAuthenticated, isChecking, setAuth]);

  // Wait for the check so logged-in users don't see the guest layout flash first.
  if (auth.isAuthenticated === null || isChecking) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        <LoadingSpinner height={100} width={100} />
      </div>
    );
  }

  return <Outlet />;
}

export default PublicRoute;
